@if (tripBookingPackage && tripBookingPackage.trip_package) {
  @if (tripBookingPackage.target == 'trip_packages' || !tripBookingPackage.target) {
    <trip-package-booking></trip-package-booking>
  }
}
@if (tripBookingPackage.target == 'product') {
  <product-booking></product-booking>
}

@if (tripBookingPackage.target == 'trenitalia') {
  @if (!tripBookingPackage.parent_trip_booking_package_relation_type) {
    <trenitalia-booking
    ></trenitalia-booking>
  }
}

@if (tripBookingPackage && tripBookingPackage.target == 'milano_card' || tripBookingPackage.target == 'milano_card_offline') {
  <ticket-booking [iterationData]="{is_first: first, is_last: last}"></ticket-booking>
}